import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const PayXGetFreeStyle = StyleSheet.create({
    flex: {
        flex: 1
    },
    inputFlex: {
        flex: 0.5
    },
    buttonFont: {
        fontSize: fontSize?.smallFontSize,
        fontFamily: appFonts?.bold,
        color: appColors?.light
    },
    searchView: {
        flexDirection: 'row',
        marginTop: 10,
        marginHorizontal: 7
    },
    searchInputContainer: {
        backgroundColor: appColors.light
    },
    searchInput: {
        marginRight: '10%',
        fontFamily: appFonts.medium,
        color: appColors.lightDark
    },
    buttonContainerStyle: {
        marginHorizontal: 5,
        marginTop: 15
    },
    iconTextStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.smallHeaderFontSize
    },
    iconView: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'center',
        borderWidth: 1,
        borderRadius: 7,
        paddingHorizontal: 10,
        paddingVertical: 6,
        borderColor: appColors.lightGrey,
    },
    iconStyle: {
        color: appColors.grey,
        paddingRight: 5
    },
    disableStyle: {
        fontSize: fontSize?.smallFontSize,
        padding: 0,
        fontFamily: appFonts.medium
    },
    contentView: {
        flexDirection: "row"
    },
    textStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.badgeFontSize,
        color: appColors.lightDark,
        paddingHorizontal: 8,
        textAlign: 'center'
    },
    statusBadgeContainer: {
        justifyContent: 'center',
        marginLeft: 7
    },
    floatIcon: {
        position: "absolute",
        width: 60,
        height: 60,
        borderRadius: 32,
        top: '90%',
        left: '80%',
        justifyContent: 'center'
    },
    badgeStyle: {
        backgroundColor: '#ffedbd',
        borderRadius: 8
    },
    itemView: {
        flexDirection: 'column',
        marginTop: 10
    },
    containerCard: {
        borderRadius: 10,
        elevation: 0,
        borderColor: 'transparent'
    },
    actionIconView: {
        alignItems: 'flex-end',
        flex: 0.4
    },
    filterTextStyle: {
        paddingTop: 3, fontFamily: appFonts.bold,
        fontSize: fontSize.smallHeaderFontSize
    },
    badgeContainer: {
        position: "absolute",
        right: -7,
        top: -7
    },
    actionIconStyle: {
        borderWidth: 1,
        borderRadius: 11,
        borderColor: appColors.light,
        backgroundColor: appColors.lightBackgroundColor
    },
    loader: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    buttonTitleStyle: {
        fontSize: fontSize.mediumFontSize,
        fontFamily: appFonts.bold
    },
    errorStyle: {
        color: appColors.red,
        fontFamily: appFonts.medium,
        fontSize: fontSize.errorFontSize,
        marginLeft: 1
    },
    labelStyle: {
        fontSize: fontSize.smallerFontSize,
        color: appColors.labelColor
    },
    borderColor: {
        borderColor: appColors?.lightGrey
    },
    dropView: {
        flex: 0.5,
        marginTop: 10
    },
    cardView: {
        borderRadius: 16,
        marginBottom: 10,
        marginTop: 0,
        elevation: 0,
        borderColor: 'transparent'
    },
    buttonTextStyle: {
        color: appColors.primary,
        fontFamily: appFonts.bold,
        fontSize: fontSize.mediumFontSize
    },
    btnStyle: {
        borderRadius: 7,
        borderWidth: 1,
        borderColor: appColors.primary,
    },
    buttonView: {
        flexDirection: 'row',
        alignSelf: 'flex-end',
        marginRight: 20,
        marginBottom: 10
    },
    searchTextStyle: {
        marginLeft: -3,
        color: appColors.grey,
        fontSize: fontSize.smallerFontSize
    },
    searchContainer: {
        borderWidth: 0.3,
        borderColor: appColors.grey,
        borderBottomWidth: 0.3
    },
    container: {
        flex: 1,
        backgroundColor: appColors.lightBackgroundColor
    },
    checkboxView: {
        flexDirection: 'row',
        flex: 0.5,
        alignItems: 'center'
    },
})